import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./App.css";
import "./RootColor.css";
import HomePage from "./pages/homePage/HomePage";
import Header from "./components/header/Header";
import ContactUs from "./pages/contact-us/ContactUs";
import AboutUs from "./pages/about-us/AboutUs";
import Products from "./pages/products/Products";
import { useState } from "react";
import Certificates from "./pages/certificates/Certificates";
import Articles from "./pages/articles/Articles";
import ArticleDetail from "./pages/articles/articleDetail/ArticleDetail";
import DataContextProviderr from "./context/DataContextProviderr";

function App() {
  const [indexProducts, setIndexProducts] = useState();
  return (
    <Router>
      <DataContextProviderr>
        <div className="App">
          <Header />
          <Routes>
            <Route
              path="/"
              element={<HomePage setIndexProducts={setIndexProducts} />}
            />
            <Route path="/contactUs" element={<ContactUs />} />
            <Route path="/aboutUs" element={<AboutUs />} />
            <Route
              path="/products"
              element={<Products indexProducts={indexProducts} />}
            />
            <Route path="/certificates" element={<Certificates />} />
            <Route path="/news" element={<Articles />} />
            <Route path="/newsDetail/:id/:seoUrlTitle" element={<ArticleDetail />} />
          </Routes>
        </div>
      </DataContextProviderr>
    </Router>
  );
}

export default App;
